import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const CartTimer = ({ removeAllItems = () => {} }) => {
  const { t } = useTranslation("common");
  const { setting } = useSelector((store) => store.settingsReducer);
  const { cartTime } = useSelector((store) => store.bookingReducer);
  const cartTimer = setting?.data?.checkoutTimer;
  const [countDownTime, setCountDownTime] = useState(cartTime);
  const minutes = Math.floor(countDownTime / 60);
  const seconds = countDownTime % 60;

  useEffect(() => {
    countDownTime < 0 && removeAllItems();
  }, [countDownTime]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDownTime((prevTime) => prevTime - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [countDownTime]);

  useEffect(() => {
    const storedStartTime = cartTime;
    if (storedStartTime) {
      const elapsedTime = Math.floor(
        (Date.now() - parseInt(storedStartTime, 10)) / 1000
      );
      const remainingTime = Math.max(cartTimer * 60 - elapsedTime, 0);
      setCountDownTime(remainingTime);
      if (remainingTime == 0) {
        localStorage.removeItem("GolfCartStartTime");
        removeAllItems();
      }
    } else {
      localStorage.setItem("GolfCartStartTime", Date.now().toString());
    }
  }, [cartTime, countDownTime]);

  return (
    <div className="w-full h-auto flex flex-row items-center justify-end gap-x-1 pb-2">
      <p className="opacity-80">{t("teeTime.expiresIn")}</p>
      <div className="w-[60px] text-end">
        <p
          style={{
            fontWeight: "bold",
            fontSize: "17px",
            color: "#F00512",
          }}
        >
          {`${minutes} : ${seconds < 10 ? "0" : ""}${seconds}`}
        </p>
      </div>
    </div>
  );
};

export default CartTimer;
